import { render } from "./withdrawFunds.vue?vue&type=template&id=0828e4a0&scoped=true"
import script from "./withdrawFunds.vue?vue&type=script&lang=js"
export * from "./withdrawFunds.vue?vue&type=script&lang=js"

import "./withdrawFunds.vue?vue&type=style&index=0&id=0828e4a0&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0828e4a0"]])

export default __exports__